module.exports = __webpack_public_path__ + "static/media/rafflehouse-logo.1c5f9c25.svg";